/* Sivena product-template kit (nightsera-* content sections).
 * Loaded once from nightsera-01. Wires:
 *   - every content CTA (a[href="#nightsera-offer"]) -> smooth scroll to the buy-box offer
 *   - carousels / swipe-to-compare tracks -> drag + wheel + arrows + scroll-snap
 *   - FAQ <details> accordions (native, with a smooth max-height reveal)
 *   - re-inits on shopify:section:load (theme editor re-renders a section on open)
 */
(function(){
  'use strict';

  function offerEl(){
    return document.getElementById('nightsera-offer')
        || document.querySelector('form[action*="/cart/add"] [name="add"], product-form button[name="add"], button[name="add"]')
        || document.querySelector('[id*="__main"], #MainContent');
  }
  function scrollOffer(){
    var el=offerEl(); if(!el) return;
    var to=Math.max(0, window.scrollY + el.getBoundingClientRect().top - 24);
    try{ window.scrollTo({top:to,behavior:'smooth'}); }
    catch(e){ window.scrollTo(0,to); }
  }

  /* All CTAs inside the cloned content go to the offer (same as the competitor). */
  function wireCtas(root){
    var links=(root||document).querySelectorAll('.nsr a[href="#nightsera-offer"], .nsr a[href^="#shopify-section"]');
    [].slice.call(links).forEach(function(a){
      if(a.__nsr) return; a.__nsr=1;
      a.addEventListener('click',function(e){ e.preventDefault(); scrollOffer(); });
    });
  }

  /* Horizontal carousels / comparison tables: make the track draggable, wheel- and
   * arrow-scrollable with scroll-snap. Works whether or not the theme's Splide inits. */
  function wireScrollers(root){
    var tracks=(root||document).querySelectorAll(
      '.nsr .splide__track, .nsr .scroll, .nsr [data-vx-scroll]');
    [].slice.call(tracks).forEach(function(t){
      if(t.__nsr) return; t.__nsr=1;
      t.style.overflowX = t.style.overflowX || 'auto';
      t.style.scrollSnapType = t.style.scrollSnapType || 'x proximity';
      t.style.webkitOverflowScrolling='touch';
      /* drag-to-scroll with the mouse */
      var down=false, sx=0, sl=0, moved=false;
      t.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse' && e.button!==0) return;
        down=true; moved=false; sx=e.clientX; sl=t.scrollLeft;
        t.classList.add('nsr-dragging');
      });
      t.addEventListener('pointermove',function(e){
        if(!down) return;
        var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true;
        t.scrollLeft = sl - dx;
      });
      function up(){ down=false; t.classList.remove('nsr-dragging'); }
      t.addEventListener('pointerup',up);
      t.addEventListener('pointerleave',up);
      /* swallow click right after a drag so a drag doesn't fire a link */
      t.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
      /* vertical wheel -> horizontal when the track overflows */
      t.addEventListener('wheel',function(e){
        if(t.scrollWidth<=t.clientWidth) return;
        if(Math.abs(e.deltaY)>Math.abs(e.deltaX)){ t.scrollLeft+=e.deltaY; e.preventDefault(); }
      },{passive:false});
    });
    /* Splide arrows (if present) drive their own nearest track. */
    var arrows=(root||document).querySelectorAll('.nsr .splide__arrow');
    [].slice.call(arrows).forEach(function(btn){
      if(btn.__nsr) return; btn.__nsr=1;
      btn.addEventListener('click',function(e){
        var sp=btn.closest('.splide'); if(!sp) return;
        var track=sp.querySelector('.splide__track'); if(!track) return;
        var prev=btn.classList.contains('splide__arrow--prev');
        var step=Math.max(240, track.clientWidth*0.8);
        e.preventDefault();
        try{ track.scrollTo({left:track.scrollLeft+(prev?-step:step),behavior:'smooth'}); }
        catch(_){ track.scrollLeft+=prev?-step:step; }
      });
    });
  }

  /* FAQ <details>: native toggle works; add a smooth max-height reveal and make the
   * whole summary row the hit target. */
  function wireDetails(root){
    var ds=(root||document).querySelectorAll('.nsr details');
    [].slice.call(ds).forEach(function(d){
      if(d.__nsr) return; d.__nsr=1;
      var body=d.querySelector('summary ~ *') ||
               (function(){ var s=d.querySelector('summary'); return s?s.nextElementSibling:null; })();
      if(!body) return;
      function sync(){
        if(d.open){ body.style.maxHeight=body.scrollHeight+'px'; body.style.opacity='1'; }
        else { body.style.maxHeight='0px'; body.style.opacity='0'; }
      }
      body.style.overflow='hidden';
      body.style.transition='max-height .26s ease, opacity .26s ease';
      sync();
      d.addEventListener('toggle',sync);
      window.addEventListener('resize',function(){ if(d.open) body.style.maxHeight=body.scrollHeight+'px'; });
    });
  }

  function init(root){ wireCtas(root); wireScrollers(root); wireDetails(root); }

  if(document.readyState!=='loading') init();
  document.addEventListener('DOMContentLoaded',function(){ init(); });
  document.addEventListener('shopify:section:load',function(e){ init(e.target||document); });
  setTimeout(init,600); setTimeout(init,1800);
})();
